import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import { Grid, FormControl, InputLabel, Select, Input, MenuItem, Button, TextField, InputAdornment, IconButton } from '@material-ui/core';
import { CustomSearchBarStyles } from '../../styles/CustomStyles';
import { AppConfig } from '../../AppConfig';
import { AppButton } from './AppButton';
import Clear from '@material-ui/icons/Clear';

export class SearchBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchText: this.props.searchText || ''
    }
  }

  render() {
    return (
      <div className={css(Styles.container)}>
        <form key='form' autoComplete='off' className={css(Styles.form)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onSearch() } }}>
          <div className={css(Styles.innerContainer)}>
            {this.props.onSinglePickerFilter && this.props.singleSelectPicker &&
              <div className={css([Styles.searchContainer, this.props.pickerContainer])}>
                <FormControl key='searchKeywords' margin='normal' fullWidth className={css(Styles.formControl)}>
                  {this.props.singleSelectPicker.title &&
                    <label>{this.props.singleSelectPicker.title}</label>
                  }
                  <Select
                    onChange={this.props.onSinglePickerFilter}
                    value={this.props.singleSelectPicker.defaultValue}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center'
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center'
                      },
                      getContentAnchorEl: null,
                      className: css(Styles.menuProps),
                      classes: {
                        paper: css(Styles.paperSelect)
                      }
                    }}
                    input={<Input disableUnderline={true} />}
                    inputProps={{
                      classes: {
                        root: css(Styles.textInputStyles)
                      }
                    }}
                    className={css(Styles.selectInput)}
                  >
                    {this.props.singleSelectPicker.options && this.props.singleSelectPicker.options.map((e, i) => (
                      <MenuItem key={'picker_option_' + i} value={e.key}>{e.value}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            }
            <div className={css(Styles.searchContainer)}>
              <FormControl key='searchKeywords' margin='normal' fullWidth className={css(Styles.formControl)}>
                {/* <Input className={css(Styles.searchInput)} type='search' disableUnderline={true}
                  placeholder={this.props.hint || 'Type keywords'} value={this.state.searchText} onChange={this.onSearchKeywordsChange.bind(this)} /> */}
                <TextField
                  className={css(Styles.searchInput)}
                  value={this.state.searchText}
                  onChange={this.onSearchKeywordsChange.bind(this)}
                  disableUnderline={true}
                  placeholder={this.props.hint || 'Type keywords'}
                  InputProps={{
                    classes: {
                      root: css(Styles.inputStyle)
                    },
                    disableUnderline: true,
                    endAdornment: (
                      <InputAdornment position='end'>
                        {this.state.searchText && (
                          <IconButton onClick={()=> { this.clearSearch() } }>
                            <Clear />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </div>
            <div className={css(Styles.buttonGroup)}>
              <div className={css(Styles.buttonInnerContainer)}>
                <AppButton
                  inProcess={this.props.inProcessSearch || false}
                  buttonStyle={Styles.button}
                  buttonTextStyle={Styles.buttonText}
                  onClick={this.onSearch.bind(this)}
                  progressIcon={Styles.progressIcon}
                  buttonText={'Search'}
                />
              </div>
              {this.props.onList &&
                <div className={css(Styles.buttonInnerContainer, Styles.showRecentButtonContainer)}>
                  <AppButton
                    inProcess={this.props.inProcessOnList || false}
                    buttonStyle={Styles.button}
                    buttonTextStyle={Styles.buttonText}
                    progressIcon={Styles.progressIcon}
                    onClick={(e) => {
                      this.props.onList(e)
                      this.setState({searchText:''})
                    }}
                    buttonText={this.props.resetFilterText || 'Show recent'} />
                </div>
              }
            </div>
          </div>
        </form>
      </div>
    )
  }

  onSearchKeywordsChange = (event) => {
    const target = event.target;
    const value = target.value;
    this.setState({
      searchText: value
    })
    if(value.length === 0) this.props.onSearch('')
  }

  onSearch() {
    if (!this.state.searchText && !this.props.onSinglePickerFilter) {
      if(this.props.callSearchOnEmptyText) this.props.onSearch(this.state.searchText)
      return
    }
    this.setState({
      searchText: this.state.searchText
    })
    this.props.onSearch(this.state.searchText)
  }

  clearSearch() {
    this.setState({
      searchText: ''
    },()=>{
      this.props.onSearch('')
    })
  }

}

const Styles = (AppConfig.CUSTOM_STYLE || AppConfig.CUSTOM_STYLE_COMP.includes('SearchBar')) ? CustomSearchBarStyles : StyleSheet.create({
  buttonGroup:{
    display: 'flex',
  },
  container: {
    // minHeight: AppTheme.toolbarHeight * 2 / 3,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: 16,
    maxWidth: AppTheme.viewPort,
  },
  selectInput: {
    minWidth: 150,
    padding: 10,
    paddingLeft: 22,
    border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: AppTheme.borderRadius,
    backgroundColor: 'white',
    height: '46px !important'
  },
  searchInput: {
    minWidth: 150,
    padding: '6px 0px 6px 20px',
    paddingLeft: 22,
    border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: AppTheme.borderRadius,
    backgroundColor: 'white',
  },
  button: {
    color: AppTheme.primaryColor,
    border: '1px solid #E5E5E5',
    backgroundColor: AppTheme.secondaryBg
  },
  formControl: {
    margin: 0,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '@media (max-width: 320px)': {
      maxWidth: 300,
    },
    maxWidth: AppTheme.viewPort,
    width: '100%',
  },
  rightGridPadding: {
    paddingLeft: 19,
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      paddingLeft: 0,
    }
  },
  innerContainer: {
    display: 'flex',
    '@media (max-width: 767px)': {
      flexDirection: 'column'
    }
  },
  searchContainer: {
    flex: 1
  },
  buttonInnerContainer: {
    paddingLeft: 10,
    minWidth: 130,
    '@media (max-width: 767px)': {
      flex: 1,
      paddingLeft: 0
    }
  },
  buttonText: {
    color: AppTheme.primaryColor,
    fontWeight: 600
  },
  progressIcon: {
    color: AppTheme.primaryColor
  },
  menuProps: {
    zIndex: 130000,
    marginTop: 5
  },
  paper: {
    zIndex: 130000,
    fontSize: 16,
    color: '#222222',
    // borderRadius: AppTheme.borderRadius,
    padding: '0px 10px'
  },
  textInputStyles: {
    // padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16,
    margin: 0,
    ':focus': {
      backgroundColor: '#ffffff'
    }
  },
  singlePicker:{
    paddingRight: 10
  },
  paperSelect: {
    zIndex: 130000,
    fontSize: 16,
    color: '#222222',
    padding: '0px'
  }
})



// WEBPACK FOOTER //
// ./src/common/components/SearchBar.js